import React from 'react';

// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

const IconPlay: React.FC<IconType> = ({
  size,
  inverse,
  onClick,
  width,
  height,
  iconClassName,
}) => {

  const defaultMeasurements: Measurements = {
    height: 16,
    width: 12,
  }

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-play">
      <svg
        className="fill-current"
        width={width || measurements.width}
        height={height || measurements.height}
        viewBox="0 0 12 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1.81926 1.01176C1.03122 0.497621 0 1.07798 0 2.03562V14.6045C0 15.5621 1.03121 16.1425 1.81926 15.6284L11.4518 9.34392C12.1827 8.86703 12.1827 7.77307 11.4518 7.29618L1.81926 1.01176Z" />
      </svg>
    </Icon>
  );
};

export default IconPlay;
